let bound = false;

function markCopied(button) {
    const icon = button.querySelector('i');
    if (!icon) {
        return;
    }
    icon.classList.remove('fa-copy');
    icon.classList.add('fa-check');
    window.setTimeout(() => {
        icon.classList.remove('fa-check');
        icon.classList.add('fa-copy');
    }, 1200);
}

function copyText(text) {
    if (navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
        return navigator.clipboard.writeText(text).then(() => true).catch(() => {
            window.prompt('Copy', text);
            return false;
        });
    }
    window.prompt('Copy', text);
    return Promise.resolve(false);
}

function onCopyClick(event) {
    const button = event.target.closest('[data-copy-text]');
    if (!button) {
        return;
    }
    const text = String(button.getAttribute('data-copy-text') || '').trim();
    if (text === '') {
        return;
    }
    event.preventDefault();
    event.stopPropagation();
    copyText(text).then((copied) => {
        if (copied) {
            markCopied(button);
        }
    });
}

export function bindCopyTextButtons() {
    if (bound) {
        return;
    }
    bound = true;
    document.addEventListener('click', onCopyClick);
}
